/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: #CEFF00;
  }
`
export default class CheckIco extends PureComponent {
  render() {
    return (
      <Fragment>
<svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" css={Color}><g transform="translate(-587.793 -26.553)"><path d="M0,0H46V46H0Z" transform="translate(587.793 26.553)" fill="#fff" opacity="0"/><g transform="matrix(0.996, 0.087, -0.087, 0.996, 227.568, -17.601)"><path d="M3.541.932,17.519,0a3.541,3.541,0,1,1,0,7.082L3.541,8.014a3.541,3.541,0,1,1,0-7.082Z" transform="translate(372.121 32.426) rotate(45)" fill="#af0"/><path d="M3.541,0H38.949a3.541,3.541,0,0,1,0,7.081H3.541A3.541,3.541,0,0,1,3.541,0Z" transform="translate(408.801 18.802) rotate(128)" fill="#af0"/></g></g></svg>      </Fragment>
    )
  }
}
